import * as z from 'zod';

export const schemaAnoImplementacao = z.object({
  anoImplementacao: z
    .string()
    .nonempty({ message: 'Ano de implementação é obrigatório' })
    .regex(/^\d{4}$/, {
      message: 'Ano de implementação deve ter 4 dígitos e ser numérico',
    })
    .refine((value) => value !== '0000', {
      message: 'Ano de implementação não pode ser nulo',
    })
    .refine((value) => !isNaN(Number(value)), {
      message: 'Ano de implementação deve ser um número',
    })
    .refine((value) => /^19\d{2}$|^20\d{2}$/.test(value), {
      message: 'Ano de implementação inválido',
    }),
});

export const schemaModalAddCoop = z.object({
  nomeCooperativaEscolar: z
    .string()
    .min(1, 'Nome da cooperativa escolar é obrigatório'),
  dataFundacao: z
    .string()
    .regex(
      /^\d{2}\/\d{2}\/\d{4}$/,
      'Data da fundação deve ser no formato DD/MM/YYYY'
    )
    .refine((val) => {
      const [day, month, year] = val.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      return (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      );
    }, 'Data da fundação é inválida')
    .refine((val) => {
      const [day, month, year] = val.split('/').map(Number);
      const date = new Date(year, month - 1, day);
      const minDate = new Date(1900, 0, 1);
      const today = new Date();
      return date >= minDate && date <= today;
    }, 'Data da fundação deve ser entre 01-01-1900 e a data atual')

});
